import React from "react";

interface IPlot {
    x: number;
    y: number;
}

export interface IColor {
    r: number;
    g: number;
    b: number;
    a?: number;
}
export const setPixel = (imageData: ImageData, plot: IPlot, color:IColor) => {
    const {width, height} = imageData;
    const {x, y} = plot;
    const offset = (x + y * width) * 4;
    if (offset > width*height * 4) return;
    imageData.data[offset] = color.r;
    imageData.data[offset + 1] = color.g;
    imageData.data[offset + 2] = color.b;
    imageData.data[offset + 3] = color.a ? color.a : 255;
}

export const getPixel = (imageData: ImageData, plot: IPlot) => {
    const {width, height} = imageData;
    const {x, y} = plot;
    const offset = (x + y * width) * 4;
    if (offset > width*height * 4) return ({r:0, g: 0, b: 0, a:255});

    return ({
        r: imageData.data[offset],
        g: imageData.data[offset+1],
        b: imageData.data[offset+2],
        a: imageData.data[offset+3]
    })
}

export const drawImgToRef = (img: ImageData, ref: React.RefObject<HTMLCanvasElement>) => {
    const canvas = ref.current;
    if (!canvas) return;
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.putImageData(img, 0, 0);
}

export const canvasToBlob = (canvas: HTMLCanvasElement) => {

}
